import type { RouteRecordRaw } from 'vue-router'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import { MODELS_COMPARISON } from './routes-names'

export default (): RouteRecordRaw[] => {
  const experiments = useExperiments()
  const isNewComparisonPageActive =
    experiments['experiment.newComparisonPage'] === 'enabled'

  return [
    {
      path: '/:locale/compare',
      component: () =>
        import(
          '@backmarket/nuxt-layer-base/components/RouteRecordWithChildrenOnly/RouteRecordWithChildrenOnly.vue'
        ),
      meta: {
        cache: 'public, max-age=300',
      },
      children: [
        {
          name: MODELS_COMPARISON.HOME,
          path: 'home',
          component: () =>
            import('./pages/ModelsComparisonHome/ModelsComparisonHome.vue'),
          meta: {
            owners: ['bot-squad-content-front'],
          },
        },
        {
          name: MODELS_COMPARISON.CATEGORY,
          path: ':category',
          component: () =>
            import('./pages/ModelsComparisonSearch/ModelsComparisonSearch.vue'),
          meta: {
            owners: ['bot-squad-content-front'],
          },
        },
        {
          name: MODELS_COMPARISON.COMPARISON_RESULTS,
          path: ':productA/:productB',
          component: () =>
            isNewComparisonPageActive
              ? import(
                  './pages/ModelsComparisonResultsV2/ModelsComparisonResultsV2.vue'
                )
              : import(
                  './pages/ModelsComparisonResults/ModelsComparisonResults.vue'
                ),

          meta: {
            owners: ['bot-squad-content-front'],
          },
        },
      ],
    },
  ]
}
